import { useEffect, useState } from "react";
import { Sparkles, LayoutTemplate, FileCode2 } from "lucide-react";
import { ChoiceCard, TextField } from "./Fields";
import { PROJECT_TYPES } from "@/lib/constants";
import { useApi } from "@/lib/api";

const MODES = [
  { value: "ai", title: "Generazione AI libera", text: "L'AI progetta struttura, design e funzionalità sulla base del brief.", icon: Sparkles },
  { value: "template", title: "Template personalizzabile", text: "Parti da un template predefinito o da un tuo progetto salvato come template.", icon: LayoutTemplate },
  { value: "blank", title: "Progetto vuoto", text: "Crea manualmente pagine, sezioni e componenti.", icon: FileCode2 },
];

function TemplatePicker({ form, set }) {
  const api = useApi();
  const [tpl, setTpl] = useState(null);
  useEffect(() => { api.get("/templates").then(({ data }) => setTpl(data)); }, [api]);
  if (!tpl) return <p className="text-sm text-slate-500">Caricamento template…</p>;
  const all = [...tpl.builtin.map((t) => ({ ...t, tag: "Predefinito" })), ...tpl.projects.map((t) => ({ ...t, description: t.company_name, tag: "Tuo template" }))];
  return (
    <div className="grid gap-3 sm:grid-cols-2" data-testid="template-picker">
      {all.map((t) => (
        <ChoiceCard key={t.id} active={form.template_id === t.id} onClick={() => set({ template_id: t.id })}
          title={t.name} text={`${t.tag} · ${t.description || ""}`} testId={`template-option-${t.id}`} />
      ))}
    </div>
  );
}

export const toggleType = (types, v) => (types.includes(v) ? types.filter((x) => x !== v) : [...types, v]);

export default function StepType({ form, set }) {
  const types = form.project_types;
  return (
    <div className="space-y-8">
      <div>
        <p className="text-sm font-semibold text-slate-900">Tipologia di progetto <span className="font-normal text-slate-500">· puoi sceglierne più di una</span></p>
        <div className="mt-3 grid gap-2.5 grid-cols-2 lg:grid-cols-4" role="group" aria-label="Tipologie di progetto">
          {PROJECT_TYPES.map((t) => (
            <ChoiceCard key={t.value} multi active={types.includes(t.value)} onClick={() => set({ project_types: toggleType(types, t.value) })} title={t.label} testId={`project-type-${t.value}`} />
          ))}
        </div>
        <p className={`mt-2 text-xs ${types.length ? "text-slate-500" : "text-red-600"}`} data-testid="project-types-summary">
          {types.length ? `Selezionate: ${types.map((v) => PROJECT_TYPES.find((t) => t.value === v)?.label).join(" + ")}` : "Scegli almeno una tipologia."}</p>
      </div>
      <div>
        <p className="text-sm font-semibold text-slate-900">Modalità di partenza</p>
        <div className="mt-3 grid gap-3 md:grid-cols-3">
          {MODES.map((m) => <ChoiceCard key={m.value} {...m} active={form.start_mode === m.value} onClick={() => set({ start_mode: m.value })} testId={`start-mode-${m.value}`} />)}
        </div>
      </div>
      {form.start_mode === "template" && <TemplatePicker form={form} set={set} />}
      {form.start_mode === "ai" && (
        <TextField multiline label="Pagine o flussi richiesti (facoltativo)" value={form.required_pages} onChange={(v) => set({ required_pages: v })}
          placeholder="Es. Homepage, Servizi, Scheda servizio, Calendario, Checkout dimostrativo, Conferma" testId="brief-pages-input" />
      )}
    </div>
  );
}
